import { render } from "./OrderGroupBookingLabel.vue?vue&type=template&id=4314058c"
import script from "./OrderGroupBookingLabel.vue?vue&type=script&lang=js"
export * from "./OrderGroupBookingLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__